import type { NavigationService } from '../navigation/navigation.service';
import type { AppsService } from './apps.service';

/**
 * DEV-13600: shows the "Gift Cards" backoffice nav item, after Orders, only
 * while the current tenant's `stored_value_activate` extendable is active.
 *
 * AppController calls this on every AppsService state change (including a
 * tenant switch, which clears the previous tenant's apps) and after every
 * `initNavigation()`, because `NavigationService.init()` replaces the items
 * (DEV-15373). `addAfter()` skips names already present, so repeated calls are
 * safe.
 *
 * `permissions: ['*']` is the codebase's idiom for "show unconditionally" under
 * the app-wide `'permissions'` nav engine; omitting `permissions` would hide
 * the item. Permission-gating Gift Cards is out of scope for now.
 */
export function syncGiftCardsNavItem(appsService: AppsService, navigationService: NavigationService): void {
  if (!appsService.canActivateStoredValue()) {
    navigationService.remove('giftCards', 'default');
    return;
  }

  navigationService.addAfter(
    {
      name: 'giftCards',
      title: 'Gift Cards',
      icon: 'giftCards',
      sref: 'application.giftCards',
      permissions: ['*'],
    },
    'orders',
    'default',
  );
}
